import { IColorPalette } from '../../../typings/semantic/colorPalette';
import Box from '@mui/material/Box';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Icons } from 'copyright-clearance-center-common-ui';
import { Draggable } from 'react-beautiful-dnd';

export interface IDraggableVocabulary {
	title: string;
	id: string;
	index: number;
	palette: IColorPalette;
	className?: string;
	onMoveToTop?: (index: number) => void;
}

export const useStyles = makeStyles(() =>
	createStyles({
		moveToTopLink: {
			cursor: 'default',
			'&:hover': {
				textDecoration: 'none'
			}
		}
	})
);

const DraggableVocabulary: React.FunctionComponent<IDraggableVocabulary> = props => {
	const classes = useStyles();
	const moveToTopClick = () => {
		if (props.onMoveToTop) {
			props.onMoveToTop(props.index);
		}
	};

	return (
		<Draggable key={props.id} draggableId={props.id} index={props.index}>
			{(provided, _) => (
				<Box
					className={props.className}
					ref={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}
				>
					<span className="rup-icon rup-icon--sm" dangerouslySetInnerHTML={{ __html: Icons.DraggableIcon }} />
					<Box className="title">{props.title}</Box>
					{props.index > 0 && (
						<span className={clsx('rup-link', classes.moveToTopLink)} onClick={moveToTopClick}>
							{localize('Move to top')}
						</span>
					)}
				</Box>
			)}
		</Draggable>
	);
};

export default DraggableVocabulary;
